import { Observable, take } from 'rxjs';
import { UserProfileMin } from 'src/app/authentication/profile/models/user-profile-min';
import { Container } from 'src/app/shared/models/container.types';
import { Card, CardFooter, CardOptions } from './card';
import { MatDialogConfig } from '@angular/material/dialog';
import {
    ContainerSummaryComponent,
    ContainerSummaryComponentInputData,
} from '../../../project/component/container-summary/container-summary.component';

export class CommunityCard extends Card {
    readonly cardTypeTranslationKey = 'card.type.communityProject';
    readonly options = new CardOptions(true, false, false);

    constructor(
        containerId: string,
        userId: string,
        userName: string,
        head: CardFooter,
        picture: string,
        container: Container
    ) {
        super(containerId, userId, userName, head, picture, container);
        this.navigationUrl = 'communityprojects/' + containerId + '/summary';
    }

    public deleteCard(): Observable<unknown> {
        return;
    }

    public onCardPictureClick(): void {
        const dialogConfig =
            new MatDialogConfig<ContainerSummaryComponentInputData>();
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            container: this.rootObj,
        };

        this.dialog
            .open(ContainerSummaryComponent, dialogConfig)
            .afterClosed()
            .pipe(take(1))
            .subscribe();
    }

    static mapToCommunityCard(container: Container, user: UserProfileMin) {
        const pic = container.containerImage ?? null;

        return new CommunityCard(
            container.id,
            user.id,
            user.displayName,
            new CardFooter(container.name, user.profilePicture),
            pic,
            container
        );
    }
}
